import { useState } from "react";

import { useKeepOutAreaApi } from "@/sx-layout/components/plotmap/hooks/useKeepOutAreaApi";
import { KeepOutArea } from "@/sx-layout/components/plotmap/models";

export const useKeepOutAreas = (plotPlanId: number) => {
  const keepOutAreaApi = useKeepOutAreaApi(plotPlanId);

  const [keepOutAreas, setKeepOutAreas] = useState<KeepOutArea[]>([]);

  const refreshKeepOutAreas = async (): Promise<void> => {
    const areaRes = await keepOutAreaApi.fetchKeepOutAreas();
    setKeepOutAreas(areaRes?.keepout_areas ?? []);
  };

  return {
    keepOutAreas,
    refreshKeepOutAreas,
  } as const;
};
